var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#085488",
    fillRule: "nonzero",
    d: "M10.5 4h-9a.5.5 0 0 0-.4.8l4.5 6a.499.499 0 0 0 .8 0l4.5-6a.5.5 0 0 0-.4-.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseDown);
export default __webpack_public_path__ + "static/media/collapse-down.0fcf5197ac8df4e7580aff9dea5e46b4.svg";
export { ForwardRef as ReactComponent };